import RedesignDescriptor from './rewardsLegacyView-redesign';
import RefiveDescriptor from './rewardsLegacyView-refive';
import CanteenDescriptor from './rewardsLegacyView-canteen';
import CompanyKitchenDescriptor from './rewardsLegacyView-companykitchen';
import AramarkDescriptor from './rewardsLegacyView-aramark';
import Settings from 'src/Settings';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
